<template>
  <base-panel
    panel-type="search"
    data-test="search-panel">

    <!-- Title -->
    <template slot="title">
      <v-card-title class="pa-0">
        <h2 class="font-weight-thin"><b>Search</b></h2>
      </v-card-title>
    </template>

    <!-- Tables -->
    <template slot="content">
      <DataTable
        :empty-search-text="false"
        model="projects"/>

      <DataTable
        :empty-search-text="false"
        model="analyses"/>

      <DataTable
        :empty-search-text="false"
        model="experiments"/>

      <DataTable
        :empty-search-text="false"
        model="individuals"/>

      <DataTable
        :empty-search-text="false"
        model="samples"/>

      <DataTable
        :empty-search-text="false"
        model="submissions"/>
    </template>

  </base-panel>
</template>

<script>
import DataTable from './DataTable.vue'
import BasePanel from '../base/BasePanel.vue'

export default {
  name: 'SearchPanel',
  components: {
    DataTable,
    BasePanel
  }
}
</script>
